<template>
  <div>
    <v-navigation-drawer
      v-bind="{ ...$attrs, ...$props }"
      v-on="$listeners"
      :permanent="isNavbarPermanent"
      app
      clipped
      right
    >
      <div class="px-4 pb-4 sidebar proxima--font">
        <ul v-if="sections" class="pt-2 pr-2">
          <v-text-field
            v-model="search"
            :autofocus="!isNavbarPermanent"
            data-lpignore="true"
            label="Search"
            prepend-inner-icon="mdi-magnify"
            dense
            hide-details
            outlined
            class="mb-4"
            clearable
          />
          <template v-if="Object.keys(filteredSections).length">
            <li
              v-for="(items, sectionTitle) of filteredSections"
              :key="sectionTitle"
              class="mt-4"
            >
              <div
                class="toc-section font-weight-bold"
                @mouseover="hoveringTopic = sectionTitle"
                @mouseleave="hoveringTopic = null"
                ><a v-scroll-to="`#${slugMe(sectionTitle)}`" @click="close">{{
                  sectionTitle
                }}</a
                ><v-btn
                  x-small
                  icon
                  v-if="hoveringTopic === sectionTitle"
                  @click="copyLink(`#${slugMe(sectionTitle)}`)"
                  ><v-icon small>
                    mdi-link
                  </v-icon></v-btn
                >
              </div>
              <ul v-if="items">
                <li
                  v-for="item of items"
                  :key="item[itemTextKey]"
                  class="section-item my-1"
                  @mouseover.stop="hoveringTopic = item[itemTextKey]"
                  @mouseleave.stop="hoveringTopic = null"
                  @click="close"
                  ><a
                    v-scroll-to="{
                      el: `#${slugMe(item[itemTextKey])}`,
                      offset: -105,
                    }"
                    @click="close"
                    >{{ item[itemTextKey] }}</a
                  >
                  <v-btn
                    x-small
                    icon
                    v-if="hoveringTopic === item[itemTextKey]"
                    @click="copyLink(`#${slugMe(item[itemTextKey])}`)"
                    ><v-icon small>
                      mdi-link
                    </v-icon></v-btn
                  ></li
                >
              </ul>
            </li>
          </template>
          <li v-else class="mt-4">
            <div>Try a Differenct Search</div>
          </li>
        </ul>
      </div>
    </v-navigation-drawer>
    <v-expand-x-transition>
      <v-btn
        v-if="!isNavbarPermanent"
        color="blue white--text"
        class="menu-toggle-button"
        fixed
        top
        right
        small
        @click="open"
      >
        View Outline<v-icon right>mdi-menu</v-icon>
      </v-btn>
    </v-expand-x-transition>
    <v-snackbar
      v-model="showLinkCopiedMessage"
      timeout="-1"
      color="blue darken-2"
    >
      <h3 class="text-center">
        Link Copied to the Clipboard
      </h3>
    </v-snackbar>
  </div>
</template>

<script>
import slugMe from '@/utils/slugMe'
import { mapFields } from 'vuex-map-fields'
import _includes from 'lodash/includes'
import _each from 'lodash/each'
export default {
  name: 'AdminTableOfContentsDrawer',
  components: {},
  props: {
    sections: {
      type: Object,
      default: () => {},
      required: true,
    },
    itemTextKey: {
      type: String,
      default: 'label',
    },
  },
  data() {
    return {
      canCopy: false,
      hoveringTopic: null,
      fabHover: false,
      showLinkCopiedMessage: false,
      search: null,
    }
  },
  created() {
    this.canCopy = !!navigator.clipboard
  },
  computed: {
    ...mapFields('admin', [
      'shopSettingsScrollTarget',
      'shopSettingsScrollTargetTimeout',
    ]),
    isNavbarPermanent() {
      return !_includes(['xs', 'sm', 'md'], this.$mq)
    },
    filteredSections() {
      if (!this.search) {
        return this.sections
      }
      let filteredSections = {}
      _each(this.sections, (settings, sectionTitle) => {
        let filteredItems = settings.filter((s) =>
          s[this.itemTextKey].toLowerCase().includes(this.search.toLowerCase())
        )
        if (filteredItems.length) {
          filteredSections[sectionTitle] = filteredItems
        } else {
          let sectionTitleMatches = sectionTitle
            .toLowerCase()
            .includes(this.search.toLowerCase())
          if (sectionTitleMatches) {
            filteredSections[sectionTitle] = settings
          }
        }
      })
      return filteredSections
    }, // filteredSections
  },
  methods: {
    slugMe,
    async copyLink(hash) {
      let link = `${document.location.origin}${this.$route.path}${hash}`
      await navigator.clipboard.writeText(link)
      this.showLinkCopiedMessage = true
      setTimeout(() => {
        this.showLinkCopiedMessage = false
      }, 2000)
    },
    setScrollTarget(label) {
      if (this.shopSettingsScrollTargetTimeout) {
        clearTimeout(this.shopSettingsScrollTargetTimeout)
      }
      this.shopSettingsScrollTarget = slugMe(label)
      this.shopSettingsScrollTargetTimeout = setTimeout(
        () => (this.shopSettingsScrollTarget = null),
        2000
      )
    }, // setScrollTarget
    close() {
      this.$emit('input', false)
    },
    open() {
      this.$emit('input', true)
    },
  },
}
</script>

<style lang="scss">
.sidebar {
  ul {
    list-style-type: none;
    padding-left: 0;
    li {
      padding-left: 0px;
      a {
        text-decoration: none;
      }
    }
  }
}
.toc-section {
  font-size: 1.1rem;
  line-height: 1.3;
}
.section-item {
  line-height: 1.5;
  font-size: 0.9rem;
  font-weight: 600;
}
.menu-toggle-button {
  z-index: 4;
  &.v-btn--top {
    top: 68px;
  }
}
</style>
